import { useDirectusStore } from "@/modules/directus/store/directus";
import { readItems } from "@directus/sdk";
import { defineStore } from "pinia";
import EventInterface from "../interfaces/EventInterface";
import { ref, watch } from "vue";
import i18n from "@/plugins/i18n";

export const useEventStore = defineStore("event", () => {
  const directusStore = useDirectusStore();

  const list = ref<EventInterface[]>([]);

  const listBySub = ref<EventInterface[]>([]);

  const eventsRequested = ref(false);
  const lastRequestedSub = ref<string | null>(null);

  const getEvents = async () => {
    eventsRequested.value = true;
    list.value = (await directusStore.city?.request(
      readItems("events", {
        fields: ["*", { user_created: ["*"] }],
        filter: {
          language: {
            _or: [
              { code: { _eq: i18n.global.locale.value } },
              { code: { _eq: null } },
            ],
          },
        },
        limit: -1,
      })
    )) as EventInterface[];
  };

  const getEventsBySub = async (sub: string) => {
    lastRequestedSub.value = sub;
    listBySub.value = (await directusStore.city?.request(
      readItems("events", {
        fields: ["*"],
        filter: {
          user_created: {
            external_identifier: {
              _eq: sub,
            },
          },
          language: {
            _or: [
              { code: { _eq: i18n.global.locale.value } },
              { code: { _eq: null } },
            ],
          },
        },
      })
    )) as EventInterface[];
  };

  watch(
    () => i18n.global.locale.value,
    () => {
      if (eventsRequested.value) {
        list.value = [];
        getEvents();
      }
      if (lastRequestedSub.value) {
        listBySub.value = [];
        getEventsBySub(lastRequestedSub.value);
      }
    }
  );

  return { getEvents, getEventsBySub, list, listBySub };
});
